module.exports = __webpack_public_path__ + "static/media/step00.93a8ce48.png";